import React from "react";
import {Head} from "@inertiajs/react";
import useWithStore from "@/Hooks/useWithStore";
import useBodyClass from "@/Hooks/useBodyClass";
import useDeleteLoader from "@/Hooks/Effects/useDeleteLoader";
import useGlobalUserActivity from "@/Hooks/Effects/GlobalListeners/useGlobalUserActivity";
import useGlobalUserDataLayer from "@/Hooks/Effects/Analytics/useGlobalUserDataLayer";
import usePageChangesForYaMetrica from "@/Hooks/Effects/Analytics/usePageChangesForYaMetrica";
import useCloseModalWindows from "@/Hooks/Effects/Modals/useCloseModalWindows";
import useShowWheelOfFortune from "@/Hooks/Effects/Modals/useShowWheelOfFortune";
import useShowContinueApplication from "@/Hooks/Effects/Modals/useShowContinueApplication";
import useShowDiscountOnFirstOrder from "@/Hooks/Effects/Modals/useShowDiscountOnFirstOrder";
import useShowGiftCalendar from "@/Hooks/Effects/Modals/useShowGiftCalendar";
import useShowSecretSanta from "@/Hooks/Effects/Modals/useShowSecretSanta";
import useBasketProductsUpdate from "@/Hooks/Effects/Stores/useBasketProductsUpdate";
import useFavouritesDataChange from "@/Hooks/Effects/Stores/useFavouritesDataChange";
import useDetectLocation from "@/Hooks/Effects/Location/useDetectLocation";
import usePressPopstateButton from "@/Hooks/Effects/Navigations/usePressPopstateButton";
import usePopstateButton from "@/Hooks/Effects/GlobalListeners/usePopstateButton";
import useFatalError from "@/Hooks/Effects/Errors/useFatalError";
import {useInertiaLoader} from "@/Hooks/useInertiaLoader";
import Loader from "@/Components/Loader";
import Header from "@/Components/Site/Header";
import Nav from "@/Components/Site/Nav";
import Footer from "@/Components/Site/Footer";
import MobileNavBar from "@/Components/Site/MobileNavBar";
import Svg from "@/Components/Svg";
import ModalWindows from "@/Components/Site/ModalWindows";

const BaseLayout = (props) => {
    const {children, title = "", description = "", pathCanonical = "", robots = ""} = props;
    const loading = useInertiaLoader();

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name={`description`} content={description} />
                <link rel={`canonical`} href={pathCanonical} />
                <meta name={`robots`} content={robots} />
            </Head>
            <div id={`site`} className={`siteContainer`}>
                <Effects {...props} />
                <Header {...props} />
                <Nav {...props} />
                {loading && <Loader />}
                {children}
                <Footer {...props} />
                <MobileNavBar {...props} />
            </div>
            <button id={`backToTop`} className={`backToTop`} onClick={() => window.scrollTo(0, 0)}>
                <Svg id={`arrowDown`} className={`svg__arrowBackToTop`} />
            </button>
            <ModalWindows {...props} />
        </>
    );
}

const Effects = (props) => {
    /**
     * Добавляем слушатели на события пользователя
     */
    useGlobalUserActivity();

    /**
     * Чтобы важные изменения страницы фиксировались Яндекс Метрикой
     */
    usePageChangesForYaMetrica();

    /**
     * Если 500 ошибка
     */
    useFatalError(props);

    /**
     * Событие нажатий кнопок «Назад» или «Вперёд»
     */
    usePopstateButton();

    /**
     * Отправка user id в dataLayer (Задача № 5895)
     */
    useGlobalUserDataLayer(props);

    /**
     * Определение местоположения по IP-Адресу (Через сервис DaData)
     */
    useDetectLocation();

    /**
     * Закрытие модальных окон
     */
    useCloseModalWindows(props);

    /**
     * Показываем окно с колесом фортуны
     */
    useShowWheelOfFortune(props);

    /**
     * Модальное окно "Продолжить в приложении"
     */
    useShowContinueApplication(props);

    /**
     * Модальное окно "Скидка на первый заказ"
     */
    useShowDiscountOnFirstOrder(props);

    /**
     * Модальное окно "Весенний календарь подарков"
     */
    useShowGiftCalendar(props);

    /**
     * Модальное окно "Тайный санта"
     */
    useShowSecretSanta(props);

    /**
     * Нажатие кнопок вперед/назад
     */
    usePressPopstateButton(props);

    /**
     * обновление состояния товаров корзины
     */
    useBasketProductsUpdate(props);

    /**
     * обновление состояния товаров избранного
     */
    useFavouritesDataChange(props);

    /**
     * Удаление элемента с id "loader"
     */
    useDeleteLoader();

    /**
     * Добавляем класс для тега body
     */
    useBodyClass();

    return null;
}

export default useWithStore(BaseLayout);
